import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import NotificationSettingResource from '@ane/exp-data/lib/resources/NotificationSettingResource';
export const defaultReducerState = getDefaultAsyncWrapperObj();
const actionPrefix = 'LoadNotificationSettingList';
const loadNotificationSettingListEpicReducerArg = {
    actionPrefix: actionPrefix,
    reduxKeyNested: () => ['items'],
    loadResource: (request) => NotificationSettingResource.getNotificationSettingList(request.workspaceId, request.skip, request.top, request.searchStr),
    onCompleteSuccess: (resourcesResult) => resourcesResult,
};
export const loadNotificationSettingListEpicReducer = loadResourcesUtils(loadNotificationSettingListEpicReducerArg);
export const loadNotificationSettingListStateDefault = {
    items: getDefaultAsyncWrapperObj(),
};
// Reducer
export const LoadNotificationSettingListReducer = (state = loadNotificationSettingListStateDefault, action) => {
    state = loadNotificationSettingListEpicReducer.reduxChange(state, action);
    return state;
};
export default LoadNotificationSettingListReducer;

//# sourceMappingURL=LoadNotificationSettingList.ducks.js.map
